<template>
  <v-card outlined>
    <v-form autocomplete="off">
      <v-data-table
        :headers="headers"
        :items="items.data"
        :hide-default-header="true"
        hide-default-footer
        :loading="isLoading"
        :page.sync="page"
        :items-per-page="99999999"
        @page-count="pageCount = $event"
      >
        <template v-slot:top>
          <v-row class="fs-topbar-left" no-gutters>
            <v-col md="3">
              <div class="pt-2 pl-1 mb-1">
                <v-btn
                  v-if="!mostrarRowCrud && incluir && verificarFunc(incluir, 'visivel')"
                  :disabled="!verificarFunc(incluir, 'habilitado')"
                  @click="abrirRowNovoRegistro()"
                  class="mb-1 fs-btns-crud-grid"
                  text
                  small
                >
                  <v-icon class="mr-1">mdi-plus-box</v-icon>
                  Incluir
                </v-btn>
                <v-btn
                  v-if="!mostrarRowCrud && editar && verificarFunc(editar, 'visivel')"
                  :disabled="!verificarFunc(editar, 'habilitado')"
                  @click="abrirRowEditarRegistro()"
                  class="mb-1 fs-btns-crud-grid"
                  text
                  small
                >
                  <v-icon class="mr-1">mdi-pen</v-icon>
                  Editar
                </v-btn>
                <v-btn
                  v-if="!mostrarRowCrud && excluir && verificarFunc(excluir, 'visivel')"
                  :disabled="!verificarFunc(excluir, 'habilitado')"
                  class="mb-1 fs-btns-crud-grid"
                  @click="excluirRegistro()"
                  text
                  small
                >
                  <v-icon class="mr-1">mdi-delete</v-icon>
                  Excluir
                </v-btn>
                <v-btn
                  class="mb-1 fs-btns-crud-grid"
                  @click="salvarRegistro()"
                  v-if="mostrarRowCrud"
                  text
                  small
                >
                  <v-icon class="mr-1">mdi-content-save</v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  class="mb-1 fs-btns-crud-grid"
                  @click="cancelarCrud()"
                  v-if="mostrarRowCrud"
                  color="red"
                  text
                  small
                >
                  <v-icon class="ml-n1">mdi-close</v-icon>
                  Cancelar
                </v-btn>
              </div>
            </v-col>
            <!-- <v-col class="pt-2 pr-2 topbar-right">
              <v-btn class="float-right ml-2" style="color: #313131" small icon>
                <v-icon>mdi-filter-outline</v-icon>
              </v-btn>
              <v-text-field
                spellcheck="false"
                placeholder="Pesquisar"
                append-icon="mdi-magnify"
                background-color="white"
                v-model="textoPesquisa"
                height="20px"
                style="width: 250px"
                class="float-right"
                hide-details
                outlined
                dense
              ></v-text-field>
              <v-select
                spellcheck="false"
                style="width: 150px"
                :items="headersPesquisa"
                v-model="indexPesquisa"
                background-color="white"
                item-value="value"
                item-text="text"
                class="float-right mr-1 ml-1"
                placeholder="Pesquisar por"
                height="20px"
                hide-details
                outlined
                dense
              ></v-select>
              <v-btn
                v-if="clonar && verificarFunc(clonar, 'visivel')"
                :disabled="!verificarFunc(clonar, 'habilitado')"
                class="float-right mr-3"
                style="color: #313131"
                small
                icon
              >
                <v-icon>mdi-content-duplicate</v-icon>
              </v-btn>
              <v-btn
                v-if="imprimir && verificarFunc(imprimir, 'visivel')"
                :disabled="!verificarFunc(imprimir, 'habilitado')"
                class="float-right mr-3"
                style="color: #313131"
                small
                icon
              >
                <v-icon>mdi-printer</v-icon>
              </v-btn>
              <v-btn
                v-if="exportar && verificarFunc(exportar, 'visivel')"
                :disabled="!verificarFunc(exportar, 'habilitado')"
                class="float-right mr-3"
                style="color: #313131"
                small
                icon
              >
                <v-icon>mdi-file-excel</v-icon>
              </v-btn>
            </v-col> -->
          </v-row>
        </template>

        <template v-if="!mostrarRowCrud" v-slot:header="{ props: { headers } }">
          <thead>
            <tr>
              <th v-for="(header, index) in headers" :key="index" class="fs-header" @click="ordenarGrid(header)">
                <v-row no-gutters>
                  {{ header.text }}
                  <span v-if="orderField === header.value">
                    <v-icon v-if="order === 'ASC'">mdi-chevron-double-down</v-icon>
                    <v-icon v-if="order === 'DESC'">mdi-chevron-double-up</v-icon>
                  </span>
                  <v-spacer></v-spacer>
                  <v-menu
                    transition="slide-y-transition"
                    :close-on-content-click="false"
                    :nudge-top="28"
                    offset-y
                    left
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-if="header.filtros"
                        v-on="on"
                        @click="montarArrayFiltroCol(header)"
                        :class="header.filtros.length > 0 ? 'fs-icon-filter-grid-selecionado' : 'fs-icon-filter-grid'"
                      >
                        mdi-filter-variant
                      </v-icon>
                    </template>
                    <v-list class="fs-menu-filtro">
                      <v-list-item v-for="(item, index) in itensColSelecFiltro" :key="index" class="fs-item-menu-filtro">
                        <v-checkbox
                          :value="item[0][colSelecFiltro.value]"
                          @change="filtrarCabecalho(header)"
                          v-model="header.filtros"
                          class="pa-0 ma-0 ml-n2"
                          hide-details
                          dense
                        >
                        </v-checkbox>
                        {{ item[0][colSelecFiltro.value] }}
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-row>
              </th>
            </tr>
          </thead>
        </template>

        <template v-slot:body="{ items }">
          <tbody>
            <!-- LINHA DO CRUD / FORMULARIO -->
            <tr v-if="mostrarRowCrud" class="fs-table-row-incluir">
              <td colspan="100">
                <v-row class="ml-n2 mr-n1 mt-1 mb-3" no-gutters>
                  <v-col md="3" lg="2" v-for="(item, index) in formfields" :key="index">
                    <v-text-field
                      v-if="!item.select"
                      :label="item.required ? `${item.text} *` : item.text"
                      :style="item.width ? `width: ${item.width}` : ''"
                      v-model="registroCrud[item.value]"
                      :autofocus="index === 0"
                      class="mt-3 mb-1 mx-2"
                      spellcheck="false"
                      placeholder=" "
                      height="20px"
                      hide-details
                      outlined
                      dense
                    >
                    </v-text-field>
                    <v-select
                      v-if="item.select"
                      :label="item.required ? `${item.text} *` : item.text"
                      :style="item.width ? `width: ${item.width}` : ''"
                      v-model="registroCrud[item.value]"
                      :autofocus="index === 0"
                      :items="item.select.length > 0 ? item.select : item.data"
                      spellcheck="false"
                      :item-value="item.relation && item.relation.value ? item.relation.value : 'value'"
                      :item-text="item.relation && item.relation.text ? item.relation.text : 'text'"
                      class="mt-3 mb-1 mx-2"
                      placeholder=" "
                      height="20px"
                      hide-details
                      outlined
                      dense
                    ></v-select>
                  </v-col>
                </v-row>
              </td>
            </tr>

            <!-- REGISTROS DO GRID -->
            <tr
              :class="rowSelecionada === item ? 'fs-tr-selected' : ''"
              @click="rowSelecionada === item ? rowSelecionada = null : rowSelecionada = item"
              v-for="(item, index) in items"
              :key="index"
            >
              <td v-for="(h, index) of headers" :key="index" :width="h.width ? h.width : null">
                <v-chip v-if="item[h.value] === 'S'" class="fs-chip" small color="green" text-color="white">Sim</v-chip>
                <v-chip v-else-if="item[h.value] === 'N'" class="fs-chip" small color="red" text-color="white">Não</v-chip>
                <span v-else>{{ item[h.value] }}</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>

      <v-row v-if="!mostrarRowCrud" class="ml-2 mr-6 mt-2 mb-2" no-gutters>
        <v-col cols="12">
          <v-row align="center" justify="space-between">
            <v-card class="ml-3" flat>
              <v-btn-toggle
                v-model="itemsPerPage"
                mandatory
                group
                dense
              >
                <v-btn :value="10" class="fs-btn-limit">10</v-btn>
                <v-btn :value="15" class="fs-btn-limit">15</v-btn>
                <v-btn :value="20" class="fs-btn-limit">20</v-btn>
                <v-btn :value="50" class="fs-btn-limit">50</v-btn>
                <v-btn :value="999999999" class="fs-btn-limit">Listar Todos</v-btn>
              </v-btn-toggle>
            </v-card>
            <div class="text-center">
              <v-pagination
                circle
                v-model="page"
                :length="items.lastPage"
                total-visible="4"
              ></v-pagination>
            </div>
          </v-row>
        </v-col>
      </v-row>
      <confirm ref="confirm"></confirm>
    </v-form>
  </v-card>
</template>

<script>
import confirm from '@/components/generic/confirm'
import { mapState, mapMutations } from 'vuex'
import { list, add, edit, del } from '@/api/crud'
import moment from 'moment'
import lodash from 'lodash'

export default {
  props: {
    headers: Array,
    formfields: Array,
    url: String,
    tela: String,
    incluir: String,
    editar: String,
    excluir: String,
    exportar: String,
    imprimir: String,
    clonar: String
  },
  components: {
    confirm
  },
  data () {
    return {
      page: 1,
      funcionalidades: [],
      headersPesquisa: [],
      indexPesquisa: null,
      textoPesquisa: '',
      rowSelecionada: null,
      modoIncluir: false,
      mostrarRowCrud: false,
      registroCrud: {},
      itemsPerPage: null,
      order: 'ASC',
      orderField: '',
      isLoading: true,
      colSelecFiltro: null,
      itensColSelecFiltro: [],
      items: {}
    }
  },

  computed: {
    ...mapState({
      confirm: state => state.global.confirm
    })
  },

  watch: {
    page: {
      handler: function (val, oldVal) {
        this.getDataFromApi()
      },
      deep: true
    },
    itemsPerPage: {
      handler: function (val, oldVal) {
        this.page = 1
        this.getDataFromApi()
      },
      deep: true
    }
  },

  created () {
    document.onkeydown = ({ keyCode, ctrlKey, altKey }) => {
      // console.log(keyCode)
      if (keyCode === 73 && ctrlKey && altKey) {
        if (this.verificarFunc(this.incluir, 'habilitado')) this.abrirRowNovoRegistro() // Ctrl + Alt + i // Incluir
      }
      if (keyCode === 85 && ctrlKey && altKey) {
        if (this.verificarFunc(this.editar, 'habilitado')) this.abrirRowEditarRegistro() // Ctrl + Alt + u // Editar
      }
      if (keyCode === 13) {
        if (this.verificarFunc(this.editar, 'habilitado') && this.rowSelecionada) {
          this.abrirRowEditarRegistro() // Enter // Editar
        }
      }
      if (keyCode === 46) {
        if (this.verificarFunc(this.excluir, 'habilitado')) this.excluirRegistro() // DELETE
      }
      if (keyCode === 83 && ctrlKey && altKey) this.salvarRegistro() // Ctrl + Alt + s // Salvar
      if ((keyCode === 67 && ctrlKey && altKey) || keyCode === 27) this.cancelarCrud() // Ctrl + Alt + c // Cancelar
      if (keyCode === 38) this.selecionarRegistroAnterior() // Seta para CIMA
      if (keyCode === 40) this.selecionarProximoRegistro() // Seta para BAIXO
    }
  },

  mounted () {
    const userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
    this.funcionalidades = userInfo.acesso.funcionalidades
    moment.locale('pt-br')
    this.montarHeadersPesquisa()
    this.limitarRegistrosParaResolucao() // Verifica a altura da tela e altera o itemsPerPage para fazer a request.
    this.verificarRelacionamentosForm()
  },

  methods: {
    ...mapMutations({
      setSnackbar: 'global/setSnackbar'
    }),
    verificarFunc (value, param) {
      if (!this.funcionalidades[value]) return false
      if (this.funcionalidades[value][param] === 'S') return true
      return false
    },
    async getDataFromApi () {
      try {
        this.items = await list(this.url, this.tela, { page: this.page, itemsPerPage: this.itemsPerPage, order: this.order })
        for (const h of this.headers) {
          if (h.relation) {
            const values = h.relation.split('.')
            this.items.data = await this.items.data.map(item => {
              if (values.length === 2) item[h.value] = item[values[0]][values[1]]
              if (values.length === 3) item[h.value] = item[values[0]][values[1]][values[2]]
              return item
            })
          }
        }
        this.items.original = this.items.data.slice()
        this.isLoading = false
      } catch (error) {
        this.setSnackbar({ msg: error, color: 'red', timeout: 7000 })
      }
    },
    montarHeadersPesquisa () {
      const aux = this.headers.slice()
      aux.unshift({ value: 'todos', text: 'Todos' })
      this.headersPesquisa = aux
    },
    limitarRegistrosParaResolucao () {
      // Ajuste da quantidade de itens do grid para a resolução da tela
      const h = this.$vuetify.breakpoint.height
      if (h > 767 && h < 900) {
        this.itemsPerPage = 15
      } else if (h > 900) {
        this.itemsPerPage = 20
      }
    },
    async verificarRelacionamentosForm () {
      for (const field of this.formfields) {
        if (field.relation) {
          const res = await list(field.relation.url, null, { itemsPerPage: 999999999 })
          field.data = res.data
        }
      }
    },
    montarArrayFiltroCol (header) {
      this.colSelecFiltro = header
      this.itensColSelecFiltro = lodash.groupBy(this.items.original, header.value)
    },
    ordenarGrid ({ value }) {
      this.orderField = value
      if (this.order === 'ASC') {
        this.items.data.sort(function (a, b) { return (a[value] > b[value]) ? 1 : ((b[value] > a[value]) ? -1 : 0) })
        this.order = 'DESC'
      } else {
        this.items.data.sort(function (a, b) { return (a[value] < b[value]) ? 1 : ((b[value] < a[value]) ? -1 : 0) })
        this.order = 'ASC'
      }
    },
    filtrarCabecalho () {
      const arrFiltros = []
      for (const header of this.headers) {
        if (header.filtros && header.filtros.length > 0) {
          for (const filtro of header.filtros) {
            arrFiltros.push({ field: header.value, value: filtro })
          }
        }
      }
      if (arrFiltros.length > 0) {
        this.items.data = this.items.original.filter(item => {
          for (const filtro of arrFiltros) {
            if (item[filtro.field] === filtro.value) return item
          }
        })
      } else {
        this.items.data = this.items.original
      }
    },
    selecionarRegistroAnterior () {
      if (!this.mostrarRowCrud) {
        if (this.rowSelecionada) {
          const index = this.items.data.indexOf(this.rowSelecionada)
          if (index - 1 >= 0) this.rowSelecionada = this.items.data[index - 1]
        } else {
          this.rowSelecionada = this.items.data[this.items.data.length - 1]
        }
      }
    },
    selecionarProximoRegistro () {
      if (!this.mostrarRowCrud) {
        if (this.rowSelecionada) {
          const index = this.items.data.indexOf(this.rowSelecionada)
          if (index < this.items.data.length - 1) this.rowSelecionada = this.items.data[index + 1]
        } else {
          this.rowSelecionada = this.items.data[0]
        }
      }
    },
    abrirRowNovoRegistro () {
      this.rowSelecionada = null
      this.registroCrud = {}
      this.mostrarRowCrud = true
      this.modoIncluir = true
    },
    abrirRowEditarRegistro () {
      if (this.rowSelecionada) {
        this.mostrarRowCrud = true
        this.registroCrud = this.rowSelecionada
      } else {
        this.setSnackbar({ msg: 'Não há nenhum registro selecionado!', color: 'red' })
      }
    },
    cancelarCrud () {
      this.mostrarRowCrud = false
      this.modoIncluir = false
    },
    async salvarRegistro () {
      const registroCrud = this.validarFormulario()
      if (registroCrud) {
        if (this.modoIncluir) { // VERIFICA SE É INCLUSÃO OU EDIÇÃO
          try {
            await add(this.url, null, registroCrud) // Validar
            this.getDataFromApi()
            this.modoIncluir = false
            this.mostrarRowCrud = false
            this.registroCrud = {}
            this.setSnackbar({ msg: 'Registro adicionado com sucesso!', color: 'green' })
          } catch (error) {
            this.setSnackbar({ msg: error, color: 'red', timeout: 7000 })
          }
        } else {
          try {
            await edit(this.url, null, this.registroCrud.id, registroCrud)
            this.getDataFromApi()
            this.mostrarRowCrud = false
            this.setSnackbar({ msg: 'Registro atualizado com sucesso!', color: 'green' })
          } catch (error) {
            this.setSnackbar({ msg: error, color: 'red', timeout: 7000 })
          }
        }
      }
    },
    async excluirRegistro () {
      if (this.rowSelecionada) {
        if (await this.confirm.open('Excluir Registro', 'Tem certeza que deseja prosseguir?', { color: 'red' })) {
          try {
            await del(this.url, null, this.rowSelecionada.id)
            this.getDataFromApi()
            this.setSnackbar({ msg: 'Registro excluído com sucesso!', color: 'green' })
          } catch (error) {
            this.setSnackbar({ msg: error, color: 'red' })
          }
        }
      } else {
        this.setSnackbar({ msg: 'Não há nenhum registro selecionado!', color: 'red' })
      }
    },
    validarFormulario () {
      const aux = {}
      for (const item of this.formfields) {
        if (item.required) {
          if (!this.registroCrud[item.value]) {
            this.setSnackbar({ msg: 'Há campos obrigatórios que não foram preenchidos!', color: 'red' })
            return false
          }
        }
        aux[item.value] = this.registroCrud[item.value]
      }
      return aux
    }
  }
}
</script>

<style scoped>
.fs-icon-filter-grid, .fs-icon-filter-grid-selecionado {
  font-size: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0);
  border-radius: 50%;
  padding: 3px;
  margin-top: -1px;
}
.fs-icon-filter-grid-selecionado {
  border: 1px solid rgba(255, 0, 0, 0.404);
  color: rgba(255, 0, 0, 0.767) !important;
}
.fs-icon-filter-grid:hover {
  background-color: #CCC;
  cursor: pointer;
  color: rgb(66, 66, 66);
}
.fs-menu-filtro {
  border: 1px solid #CCC !important;
}
.fs-item-menu-filtro {
  min-height: 25px !important;
  text-align: center;
  font-size: 12px;
}
.fs-item-menu-filtro:hover {
  background-color: rgba(224, 224, 224, 0.61);
}
.fs-header:hover {
  cursor: pointer;
  font-weight: bold;
  transition: .2s;
  color: rgb(0, 0, 0) !important;
}
.fs-table-row-incluir:hover {
  background-color: white !important;
}
.fs-topbar-left {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  background-color: rgb(240, 240, 240);
}
.float-right {
  float: right;
}
.fs-btns-crud-grid {
  padding: 3px !important;
  margin-left: 5px;
}
.fs-btn-limit {
  font-size: 11px !important;
  letter-spacing: .3px;
  border-radius: 0px !important;
}
</style>
